
import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";

export let logger;

datadogRum.init({
  applicationId: "8e07c8e1-beab-44d7-8532-12568505eb2c",
  clientToken: "pub23a3762acfea01c585e90f9cce2db2d7",
  sessionSampleRate: 1,
  sessionReplaySampleRate: 1,
  service:"web",
  site: "datadoghq.com",
  trackInteractions: true,
  env: "production",
  version: "",
});
datadogRum.startSessionReplayRecording();

// Attach the active Datadog RUM session to every Rollbar item so each
// Rollbar occurrence links back to the corresponding RUM session replay.
if (window.Rollbar) {
  window.Rollbar.configure({
    transform: (payload) => {
      const ctx = datadogRum.getInternalContext();
      if (!ctx) return;
      payload.datadog = {
        session_id: ctx.session_id,
        view_id: ctx.view?.id,
        application_id: ctx.application_id,
      };
    },
  });
}

// Initialize Datadog logger
datadogLogs.init({
  clientToken: "pub9fb9300e06308781c27de6194d49aa0d",
  env: "production",
  service: "browser",
  beforeSend: (log) => {
    log.rinsed = log.rinsed || {};
    log.rinsed.tenant = document.body.dataset.tenant;
    log.rinsed.custom_domain = document.body.dataset.custom_domain;
    log.rinsed.customer_portal_session_eid = document.body.dataset.customer_portal_session_eid;
    log.rinsed.customer_portal_session_pwa = document.body.dataset.customer_portal_session_pwa;
  },
});

logger = datadogLogs.logger;

